import React from 'react';
import styled from 'styled-components';
import { withProductQuantity } from '@catalogo/service-americanas-product/src/hocs/product-quantity';

export const SelectorQuantity = props => {
  const { productQty: selectedQty, history, limit } = props;

  return (
    <Container>
      <b>quantidade :</b> {selectedQty} unidade{selectedQty > 1 && 's'}&nbsp;
      <Link onClick={openModal(history, limit)}>alterar</Link>
    </Container>
  );
};

export function openModal(history, limit) {
  const { pathname, search } = history.location;
  return () => history.replace({ pathname, search, hash: '#modal-select-qty', state: { limit } });
}

const Container = styled.p`
  text-align: center;
  margin-bottom: 18px;
`;

const Link = styled.a`
  cursor: pointer;
  text-decoration: underline;

  :hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

export default withProductQuantity(SelectorQuantity);
